import { Skeleton, Box, Stack, Grid2 } from "@mui/material";

const TicketCardSkeleton = () => {
    return (
        <Stack spacing={2}>
            {[...Array(3)].map((_, idx) => (
                <Box
                    key={idx}
                    sx={{
                        // bgcolor: "#1e1e1e",
                        borderRadius: "12px",
                        p: 2,
                        width: "100%",
                        border: "1px solid #20263024",
                    }}
                >
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="text" width="60%" height={24} />
                        <Skeleton variant="text" width={80} height={20} />
                    </Stack>

                    <Skeleton variant="text" width="40%" height={30} sx={{ mt: 2 }} />
                    <Skeleton variant="text" width="70%" height={20} />

                    <Grid2 container spacing={1} sx={{ mt: 2 }}>
                        <Grid2 item>
                            <Skeleton variant="rounded" width={60} height={30} />
                        </Grid2>
                        <Grid2 item>
                            <Skeleton variant="rounded" width={100} height={30} />
                        </Grid2>
                    </Grid2>
                </Box>
            ))}
        </Stack>
    );
};

export default TicketCardSkeleton;
